export let markSpecs = {
  bold: {
    parseDOM: [{
      tag: 'strong'
    }, {
      tag: 'b'
    }, {
      style: 'font-weight',
      getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
    }],
    toDOM() {
      return ['b', 0];
    }
  },
  italic: {
    parseDOM: [{
      tag: 'i'
    }, {
      tag: 'em'
    }, {
      style: 'font-style=italic'
    }],
    toDOM() {
      return ['i', 0];
    }
  },
  code: {
    parseDOM: [{
      tag: 'code'
    }],
    toDOM() {
      return ['code', 0];
    },
    inclusive: false
  },
  anchor: {
    parseDOM: [{
      tag: 'a',
      getAttrs(dom) {
        return {
          href: dom.getAttribute('href')
        };
      }
    }],
    attrs: {
      href: {
        default: ''
      }
    },
    inclusive: false,
    // Whether this mark should be active when the cursor is positioned at its end
    toDOM(mark) {
      return ['a', {
        href: mark.attrs.href
      }, 0];
    }
  },
  underline: {
    parseDOM: [{
      tag: 'u'
    }],
    toDOM() {
      return ['u', 0];
    }
  },
  span: {
    parseDOM: [{
      tag: 'span',
      getAttrs(dom) {
        let style = dom.getAttribute('style');
        return {
          style
        };
      }
    }],
    attrs: {
      style: {
        default: ''
      }
    },
    toDOM(mark) {
      let {
        style
      } = mark.attrs;
      return ['span', {
        style
      }, 0];
    }
  },
  deletion: {
    parseDOM: [{
      tag: 'mark[data-mark-type="deletion"]'
    }],
    toDOM() {
      return ['mark', {
        'data-mark-type': 'deletion'
      }, 0];
    },
    serializable: false
  },
  insertion: {
    parseDOM: [{
      tag: 'mark[data-mark-type="insertion"]'
    }],
    toDOM() {
      return ['mark', {
        'data-mark-type': 'insertion'
      }, 0];
    },
    serializable: false
  }
};